export const isNotEmpty = (inputValue) => {
  try {
    if (inputValue === true) {
      return true
    }
    return  !!inputValue?.replace(/[\s]/, '')
  } catch (e) {
    return false;
  }
};
